<template>
  <div>
    <v-tabs right dark color="cyan" class="mt-5">
      <v-tab v-for="tab in tabs" :key="tab.id" active-class="active-tab">
        {{ tab.name }}
      </v-tab>
      <v-tab-item v-for="tab in tabs" :key="tab.id">
        <v-layout row wrap v-if="tab.id === 1" ma-5>
          <!-- <v-flex xs12 mb-3>
											dnasjdnas
											{{ Object.keys($v.model).filter(key => $v.model[key].$invalid) }}
										</v-flex> -->
          <v-flex xs12 mb-3 v-if="flagCompanyParent">
            <v-flex xs5>
              <v-select
                box
                solo
                background-color="white"
                class="body-1"
                hide-details
                label="Compañía maestra"
                item-text="nombreComercial"
                item-value="id"
                :items="masterCompanies"
                v-model="model.masterCompany"
              ></v-select>
            </v-flex>
          </v-flex>
          <v-flex xs5 mr-5 mb-3>
            <v-text-field
              box
              solo
              background-color="white"
              class="body-1"
              hide-details
              label="Nombre Comercial"
              required
              v-model="model.nameCommercial"
              :error="$v.model.nameCommercial.$error"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs5>
            <v-text-field
              box
              solo
              background-color="white"
              class="body-1"
              hide-details
              label="Razón Social"
              v-model="model.businessName"
              :error="$v.model.businessName.$error"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs5 mr-5>
            <v-text-field
              box
              solo
              background-color="white"
              class="body-1"
              hide-details
              label="Código de Compañia"
              v-model="model.codeCompany"
              :error="$v.model.codeCompany.$error"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs5 mb-3>
            <v-select
              box
              solo
              background-color="white"
              class="body-1"
              hide-details
              label="País"
              item-text="name"
              item-value="id"
              :items="countries"
              v-model="model.country"
            ></v-select>
          </v-flex>
          <v-flex xs11 mb-3>
            <v-text-field
              box
              solo
              background-color="white"
              class="body-1"
              hide-details
              label="Ruc"
              type="number"
              v-model="model.ruc"
              :error="$v.model.ruc.$error"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs11 mb-3>
            <v-text-field
              box
              solo
              background-color="white"
              class="body-1"
              hide-details
              label="Dominio"
              v-model="model.domain"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs11 mb-3>
            <v-select
              box
              solo
              background-color="white"
              class="body-1"
              hide-details
              label="Plan"
              item-text="name"
              item-value="id"
              :items="plans"
              v-model="model.typePlan"
            ></v-select>
          </v-flex>
          <v-flex xs11 mb-3>
            <v-select
              box
              solo
              background-color="white"
              class="body-1"
              hide-details
              label="Rubro"
              item-text="name"
              item-value="id"
              :items="rubros"
              v-model="model.heading"
            ></v-select>
          </v-flex>
          <!-- <v-flex xs11 mb-3>
            <v-select
              background-color="white"
              box
              class="body-1"
              hide-details
              item-text="name"
              item-value="id"
              label="Distribuidores"
              :items="listDistributors"
              v-model="model.idDistributor"
            ></v-select>
          </v-flex> -->
          <v-flex xs5 mb-3>
            <v-select
              background-color="white"
              box
              class="body-1"
              hide-details
              label="Documento"
              :items="codesDocuments"
              :returnObject="false"
              v-model="document.typeDocumentCode"
            ></v-select>
          </v-flex>
          <v-flex xs5 mb-3 ml-3>
            <v-text-field
              background-color="white"
              box
              class="body-1"
              hide-details
              label="Serie"
              type="text"
              placeholder="00"
              v-model="document.serie"
              required
            />
          </v-flex>
          <v-flex xs5 mb-3>
            <v-text-field
              background-color="white"
              box
              class="body-1"
              hide-details
              label="Número"
              type="text"
              placeholder="00"
              v-model="document.number"
              required
            />
          </v-flex>
          <v-flex xs5 mb-3>
            <v-btn color="primary" @click="validateDocument"> Validar </v-btn>
          </v-flex>
          <v-flex xs5 mb-3 ml-3>
            <span
              :class="
                model.documentParentId
                  ? 'caption green--text'
                  : ' caption grey--text'
              "
            >
              {{
                model.documentParentId
                  ? 'Documento Valido'
                  : 'Documento no seleccionado'
              }}
            </span>
          </v-flex>
          <v-flex xs12>
            <v-checkbox
              color="success"
              v-model="model.flagKardex"
              hide-details
              label="Desea trabajar con kardex"
            >
            </v-checkbox>
          </v-flex>
          <v-layout row pl-2>
            <v-flex xs3 v-for="(value, key) in languages" :key="key">
              <v-checkbox
                color="primary"
                :label="key"
                v-model="value.isSelected"
              >
              </v-checkbox>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout v-else row wrap ma-5>
          <v-flex xs12 mb-3>
            <v-text-field
              box
              solo
              background-color="white"
              type="email"
              class="body-1"
              hide-details
              label="Email"
              v-model="model.email"
              :error="$v.model.email.$error"
            >
            </v-text-field>
          </v-flex>
          <!-- <v-flex xs12 mb-3>
						<v-text-field
							box
							solo
							background-color="white"
							class="body-1"
							hide-details
							label="User"
							v-model="model.codeUser"
							:error="$v.model.codeUser.$error"
						>
						</v-text-field>
					</v-flex> -->
          <v-flex xs12 mb-3>
            <v-text-field
              box
              solo
              background-color="white"
              class="body-1"
              hide-details
              label="Password"
              type="password"
              v-model="model.password"
              :error="$v.model.password.$error"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 mb-3>
            <v-select
              box
              solo
              background-color="white"
              class="body-1"
              hide-details
              label="Roles"
              item-text="name"
              item-value="id"
              :items="rols"
              return-object
              v-model="model.idRoleSelected"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs>
    <section class="modal-filter-footer">
      <modal-sidebar-button
        :is-loading="$v.$invalid || loading"
        :on-run-service="loading"
        @accept-button-clicked="sendData"
        @cancel-button-clicked="closeModal"
      />
    </section>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import helper from '@/shared/helper';

const { getLocalData } = helper;

function validations() {
  const validation = {
    model: {
      nameCommercial: {
        required,
      },
      businessName: {
        required,
      },
      codeCompany: {
        required,
      },
      ruc: {
        required,
      },
      email: {
        required,
        email,
      },
      password: {
        required,
      },
      typePlan: {
        required,
      },
      // codeUser: {
      // 	required,
      // },
    },
  };
  return validation;
}

function closeModal() {
  this.goTo('page-template', {
    params: { projectId: this.projectId, codeProject: this.codeProject },
  });
}

function created() {
  this.idProject = this.projectId || getLocalData('project-id');
  this.templateCode = this.codeTemplate || getLocalData('code-template');
  this.loadProjects();
  this.loadCountries();
  this.loadItems();
  this.loadRols();
  this.loadPlans();
  // this.loadDistributors();
}

async function loadRols() {
  const id = this.$route.params.id;
  const headers = {
    Accept: `${process.env.ACCEPT_SERVICE_V2}`,
  };
  try {
    const response = await this.$http.get(
      `project/${this.codeProject}/template/${id}/roles`,
      { headers }
    );
    this.rols = response.data.data;
  } catch (error) {
    this.showError();
  }
}

async function loadProjects() {
  try {
    const response = await this.$http.get(`project/${this.idProject}`);
    this.languages = response.data.data.languages;
    this.isCompanyParent(response.data.data);
  } catch (error) {
    this.showError();
  }
}

async function loadCountries() {
  try {
    const response = await this.$http.get('countries');
    this.countries = response.data.data;
  } catch (error) {
    this.showError();
  }
}

async function loadItems() {
  const url = `project/${this.codeProject}/items`;
  const { data: items } = await this.$http.get(url);
  ({ data: this.rubros } = items);
}

function isCompanyParent({ flagCompanyParent }) {
  if (flagCompanyParent) {
    this.flagCompanyParent = flagCompanyParent;
    this.loadMasterCompanies();
  }
}

async function loadMasterCompanies() {
  const params = { page: 1 };
  const url = `/projects/${this.codeProject}/company-parent`;
  const { data: response } = await this.$http.get(url, { params });
  this.masterCompanies = response.data;
}

async function sendData() {
  this.loading = true;
  const headers = {
    Accept: `${process.env.ACCEPT_SERVICE_V2}`,
  };

  const body = {
    codeCompany: this.model.codeCompany,
    codeProject: this.codeProject,
    codeTemplate: this.templateCode,
    idItem: this.model.heading,
    idRoleSelected: this.model.idRoleSelected
      ? this.model.idRoleSelected.typeRoleId
      : undefined,
    // codeUser: this.model.codeUser,
    companyParentId: this.model.masterCompany,
    countryId: this.model.country,
    email: this.model.email,
    flagAppCompany: true,
    flagKardex: this.model.flagKardex,
    languages: this.languages,
    domain: this.model.domain,
    nombreComercial: this.model.nameCommercial,
    password: this.model.password,
    razonSocial: this.model.businessName,
    ruc: this.model.ruc,
    typePlan: this.model.typePlan,
    documentParentId: this.model.documentParentId,
  };
  try {
    await this.$http.post('company-template', body, {
      headers,
    });
    this.showNotification('Se creó correctamente el template');
    this.closeModal();
  } catch (err) {
    if (err.data.email) {
      this.showError(err.data.email);
    }
    // if (err.data.codeUser) {
    // 	this.showError(err.data.codeUser);
    // }
    if (err.data.codeCompany) {
      this.showError(err.data.codeCompany);
    }
  } finally {
    this.loading = false;
  }
}

function data() {
  return {
    countries: [],
    // listDistributors: [],
    flagCompanyParent: 0,
    idProject: 0,
    loading: false,
    masterCompanies: [],
    model: {
      businessName: '',
      codeCompany: '',
      codeUser: '',
      country: '',
      domain: '',
      email: '',
      flagKardex: false,
      masterCompany: 0,
      nameCommercial: '',
      password: '',
      ruc: '',
      typePlan: null,
      heading: null,
      idRoleSelected: null,
      // idDistributor: null,
      documentParentId: null,
    },
    tabs: [
      { id: 1, name: 'Datos Compañía' },
      { id: 2, name: 'Datos Usuario' },
    ],
    rubros: [],
    plans: [],
    rols: [],
    templateCode: 0,
    codesDocuments: ['BOL', 'NTV', 'FAC'],
    document: {
      serie: null,
      number: null,
      typeDocumentCode: null,
    },
  };
}
export default {
  name: 'template-form',
  created,
  data,
  methods: {
    closeModal,
    isCompanyParent,
    loadCountries,
    loadItems,
    loadProjects,
    loadMasterCompanies,
    loadRols,
    sendData,
    async loadPlans() {
      const response = await this.$http.get('type-plans');
      this.plans = response.data.data;
    },
    // async loadDistributors() {
    //   try {
    //     const response = await this.$http.get('distributaries');
    //     this.listDistributors = response.data.data;
    //   } catch (error) {
    //     this.showError(error);
    //   }
    // },
    async validateDocument() {
      const { serie, number, typeDocumentCode } = this.document;

      try {
        // Usar la baseURL dinámica
        const response = await this.$httpSales.post(
          'subsidiaries/billing-document',
          { serie, number, typeDocumentCode },
          this.configFetchValidateDoc || undefined
        );
        this.model.documentParentId = response.data.id;
        this.showNotification('El documento es válido y registrado');
      } catch (error) {
        this.model.documentParentId = null;
        this.showError('El documento no se encuentra registrado');
      }
    },
  },
  computed: {
    configFetchValidateDoc() {
      try {
        const company = this.masterCompanies.find(
          (c) => c.id === this.model.masterCompany
        );
        if (!company || (company && !company.template)) {
          return null;
        }
        const domains = company.template.data.settings.domains || [];
        const saleDomain = domains.find((d) => d.code === 'SALES_URL');
        const baseURL = saleDomain
          ? saleDomain.endPoint
          : process.env.SALES_URL;

        return {
          baseURL,
          headers: {
            Authorization: `Bearer ${company.hash}`,
          },
        };
      } catch (error) {
        return null;
      }
    },
  },
  props: {
    projectId: {
      type: [Number, String],
    },
    codeProject: {
      type: String,
    },
    codeTemplate: {
      type: [Number, String],
    },
  },
  validations,
};
</script>
<style lang="scss" scoped>
.active-tab {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/template/template-form.vue